export const UPDATE_ACCOUNT_INFORMATION = "/api/v1/me"

export const UPDATE_PERSONAL_INFORMATION = "/api/v1/me"
export const CHANGE_PASSWORD = "/api/v1/me/update-password"

export const FETCH_PROFILE = "/api/v1/me"
